import { format, parseISO } from 'date-fns';

// isZeroDate only cares about the year being set to 0001.
// Uses getUTCFullYear to avoid local-timezone offsets turning Jan 1 year 1 into Dec 31 year 0.
export const isZeroDate = (arg?: Date | string | null) => {
  if (!arg) return true;

  const date = typeof arg === 'string' ? parseISO(arg) : arg;

  return date.getUTCFullYear() === 1;
};

export const prettyDate = (arg?: Date | string | null) => {
  if (!arg || isZeroDate(arg)) return '';

  const date = typeof arg === 'string' ? parseISO(arg) : arg;

  return format(date, 'MMM d, yyyy');
};

export const prettyTime = (arg?: Date | string | null) => {
  if (!arg || isZeroDate(arg)) return '';

  const date = typeof arg === 'string' ? parseISO(arg) : arg;

  return format(date, 'h:mm a');
};

export const prettyDateTime = (arg?: Date | string | null) => {
  if (!arg || isZeroDate(arg)) return '';

  const date = typeof arg === 'string' ? parseISO(arg) : arg;

  return format(date, "MMM d, yyyy 'at' h:mm a");
};

/**
 * Formats a *calendar date* the API sent as midnight UTC — a due date, a cycle date, anything
 * that names a day rather than an instant.
 *
 * `prettyDate` would be wrong for these. It formats in the viewer's zone, so the `2026-08-14`
 * that `GET /payouts` sends as `2026-08-14T00:00:00Z` renders as "Aug 13, 2026" for everyone
 * west of Greenwich. Reading the UTC fields and rebuilding a local date keeps the day the
 * backend actually meant, in every zone.
 */
export const prettyUtcDate = (arg?: Date | string | null) => {
  if (!arg || isZeroDate(arg)) return '';

  const date = typeof arg === 'string' ? parseISO(arg) : arg;

  return format(
    new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()),
    'MMM d, yyyy'
  );
};
